<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fill-pen`]" width="1em" height="1em" v-bind="$attrs"><path d="M31.07 8.444l8.486 8.485L19.05 37.435l-8.485-8.485zM33.9 5.615a2 2 0 012.828 0l5.657 5.657a2 2 0 010 2.828l-1.414 1.415-8.486-8.486L33.9 5.615zM17.636 38.85l-8.485-8.486-3.61 10.83a1 1 0 001.264 1.265l10.831-3.61z"/></svg>
</template>
<script>

export default {
  name: 'IconFillPen',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
